@if (entity) {
<div class="flex flex-col gap-3">
  <!-- Row 1: Name (6) + Validate Button (6) -->
  <div class="grid grid-cols-12 gap-3">
    <qb-field label="Name" [class]="showValidateButton ? 'col-span-6 lg:col-span-6' : 'col-span-6'">
      <input
        #nameInput
        pInputText
        [(ngModel)]="entity[prefix + 'Name']"
        [bzModel]="entity"
        [name]="prefix + 'Name'"
        [disabled]="isReadonly"
        title="Name"
      />
    </qb-field>
    <div *ngIf="showValidateButton" class="col-span-6 lg:col-span-6 flex items-center gap-2 mt-6">
      <p-button
        (click)="validate()"
        [title]="validationTitle"
        [disabled]="isReadonly"
        label="Validate Address"
        icon="pi pi-check-circle"
        size="small"
      ></p-button>
    </div>
  </div>
  <!-- Row 2: Address 1 (6) + Address 2 (6) -->
  <div class="grid grid-cols-12 gap-3">
    <qb-field label="Address 1" class="col-span-6 lg:col-span-6">
      <input pInputText [(ngModel)]="entity[prefix + 'Address1']" [bzModel]="entity" [name]="prefix + 'Address1'" [disabled]="isReadonly" />
    </qb-field>
    <qb-field label="Address 2" class="col-span-6 lg:col-span-6">
      <input pInputText [(ngModel)]="entity[prefix + 'Address2']" [bzModel]="entity" [name]="prefix + 'Address2'" [disabled]="isReadonly" />
    </qb-field>
  </div>
  <!-- Row 2b: Address 3 (6) -->
  <div class="grid grid-cols-12 gap-3">
    <qb-field label="Address 3" class="col-span-6 lg:col-span-6">
      <input pInputText [(ngModel)]="entity[prefix + 'Address3']" [bzModel]="entity" [name]="prefix + 'Address3'" [disabled]="isReadonly" />
    </qb-field>
  </div>
  <!-- Row 3: City (4) + State (2) + Zip (2) -->
  <div class="grid grid-cols-12 gap-3">
    <qb-field label="City" class="col-span-6 lg:col-span-4">
      <input pInputText [(ngModel)]="entity[prefix + 'City']" [bzModel]="entity" [name]="prefix + 'City'" [disabled]="isReadonly" />
    </qb-field>
    <qb-field label="State" class="col-span-6 lg:col-span-2">
      <input pInputText [(ngModel)]="entity[prefix + 'State']" [bzModel]="entity" [name]="prefix + 'State'" [disabled]="isReadonly" />
    </qb-field>
    <qb-field label="Zip" class="col-span-6 lg:col-span-2">
      <input pInputText [(ngModel)]="entity[prefix + 'ZipCode']" [bzModel]="entity" [name]="prefix + 'ZipCode'" [disabled]="isReadonly" />
    </qb-field>
  </div>
  <!-- Row 4: Telephone (4) + Extension (2) -->
  <div class="grid grid-cols-12 gap-3">
    <qb-field label="Telephone" class="col-span-6 lg:col-span-4">
      <input
        pInputText
        [(ngModel)]="entity[prefix + 'Telephone']"
        [bzModel]="entity"
        [name]="prefix + 'Telephone'"
        [disabled]="isReadonly"
      />
    </qb-field>
    <qb-field label="Extension" class="col-span-6 lg:col-span-2">
      <input pInputText [(ngModel)]="entity[prefix + 'Ext']" [bzModel]="entity" [name]="prefix + 'Ext'" [disabled]="isReadonly" />
    </qb-field>
  </div>
</div>
} @else {
<div class="mt-12 ml-12">
  <h3>No Address Found</h3>
</div>
}
